import * as u from './utils';

export default () => {
    const triggers = document.querySelectorAll('.quote-request-button');
    const modal = document.querySelector('.dialog');

    if (!modal) {
        return;
    }

    const close = modal.querySelector('.dialog__close');
    const popup = modal.querySelector('.dialog__popup');

    const closeModal = () => {
        u.removeClass(modal, 'is-active');
    };

    const stopClosure = (e) => {
        e.stopPropagation();
    };

    modal.addEventListener('click', closeModal);
    popup.addEventListener('click', stopClosure);
    close.addEventListener('click', closeModal);

    for (const el of triggers) {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.currentTarget.dataset.target;
            const dialog = document.querySelector('#' + target);

            u.addClass(dialog, 'is-active');
        });
    }
};
